import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  LocalAudioTrackPublication,
  LocalVideoTrackPublication,
  Room,
} from "twilio-video";
import { AppDispatch } from "store/store";
import { RootState } from "store/reducers";

export const resetRoom = createAsyncThunk<
  Room | undefined,
  void,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>("room/resetRoom", (_, { getState }) => {
  const { room } = getState();
  room.room?.localParticipant.tracks.forEach(function (trackPublication) {
    (
      trackPublication as
        | LocalVideoTrackPublication
        | LocalAudioTrackPublication
    ).track.stop();
    trackPublication.unpublish();
  });
  room.room?.disconnect();
  return room.room;
});
